import { Nullable } from '@clearverify/types';

import { VerifierDetailInfoFragment } from 'src/api';

import {
  CommercialVerifierCompanyInformationFormFields,
  CommercialVerifierCompanyInformationFormValues,
  CompanyInformationFormAddressFields,
  GovernmentVerifierCompanyInformationFormFields,
} from '../types';

export const getCommercialVerifierInitialValues = (
  verifier: Nullable<VerifierDetailInfoFragment>,
): CommercialVerifierCompanyInformationFormValues => ({
  [CommercialVerifierCompanyInformationFormFields.displayName]: verifier?.displayName,
  [CommercialVerifierCompanyInformationFormFields.legalBusinessName]: verifier?.legalBusinessName,
  [CommercialVerifierCompanyInformationFormFields.logoFile]: verifier?.logo
    ? {
        id: verifier.logo.id,
        size: verifier.logo.size,
      }
    : null,
  [CommercialVerifierCompanyInformationFormFields.commercialName]: verifier?.commercialName,
  [CommercialVerifierCompanyInformationFormFields.fEIN]: verifier?.fEIN,
  [CommercialVerifierCompanyInformationFormFields.industry]: verifier?.industry,
  [CommercialVerifierCompanyInformationFormFields.contactEmail]: verifier?.contactEmail,
  [CommercialVerifierCompanyInformationFormFields.contactPhone]: verifier?.contactPhone,
  [CommercialVerifierCompanyInformationFormFields.websiteURL]: verifier?.websiteURL,
  [CommercialVerifierCompanyInformationFormFields.address]: {
    [CompanyInformationFormAddressFields.street]: verifier?.address?.street ?? '',
    [CompanyInformationFormAddressFields.city]: verifier?.address?.city ?? '',
    [CompanyInformationFormAddressFields.state]: verifier?.address?.state ?? '',
    [CompanyInformationFormAddressFields.county]: verifier?.address?.county ?? '',
    [CompanyInformationFormAddressFields.zipCode]: verifier?.address?.zipCode ?? '',
  },
});

export const getGovernmentVerifierInitialValues = (
  verifier: Nullable<VerifierDetailInfoFragment>,
) => ({
  [GovernmentVerifierCompanyInformationFormFields.displayName]: verifier?.displayName,
  [GovernmentVerifierCompanyInformationFormFields.logoFile]: verifier?.logo
    ? {
        id: verifier.logo.id,
        size: verifier.logo.size,
      }
    : null,
  [GovernmentVerifierCompanyInformationFormFields.governmentEntityName]:
    verifier?.governmentEntityName,
  [GovernmentVerifierCompanyInformationFormFields.typeOfGovernment]: verifier?.typeOfGovernment,
  [GovernmentVerifierCompanyInformationFormFields.department]: verifier?.department,
  [GovernmentVerifierCompanyInformationFormFields.commercialName]: verifier?.commercialName,
  [GovernmentVerifierCompanyInformationFormFields.fEIN]: verifier?.fEIN,
  [GovernmentVerifierCompanyInformationFormFields.industry]: verifier?.industry,
  [GovernmentVerifierCompanyInformationFormFields.contactEmail]: verifier?.contactEmail,
  [GovernmentVerifierCompanyInformationFormFields.contactPhone]: verifier?.contactPhone,
  [GovernmentVerifierCompanyInformationFormFields.websiteURL]: verifier?.websiteURL,
  [GovernmentVerifierCompanyInformationFormFields.address]: {
    [CompanyInformationFormAddressFields.street]: verifier?.address?.street ?? '',
    [CompanyInformationFormAddressFields.city]: verifier?.address?.city ?? '',
    [CompanyInformationFormAddressFields.state]: verifier?.address?.state ?? '',
    [CompanyInformationFormAddressFields.county]: verifier?.address?.county ?? '',
    [CompanyInformationFormAddressFields.zipCode]: verifier?.address?.zipCode ?? '',
  },
});
